import { useState, Fragment, useEffect } from "react";
import React from "react";
import Button from "../../../components/button";
import validator from "validator";
import Input from "../../../components/input";
import axios from "axios";
import ApiMethods from "../../../../ApiManager/ApiMethods";
import { useAlert } from "../../../context/AlertContext";
import { useNavigate } from "react-router-dom";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Box from "@mui/material/Box";
import { useUser } from "../../../context/UserContext";
import { jwtDecode } from "jwt-decode";
import { useLocation } from "react-router-dom";

const Register = ({ handleToggle, loginVerification }) => {
  const [email, setEmail] = useState("");
  const [firstName, setFirstName] = useState("");
  const [phone, setPhone] = useState("");
  const { setUser } = useUser();
  const location = useLocation();
  const [token, setToken] = useState(() => localStorage.getItem("token"));
  const [activeClientId, setClientActiveId] = useState(null);
  const [lastName, setLastName] = useState("");
  const [alert, setAlert] = useState();
  const [address, setAddress] = useState("");

  const [nickname, setNickName] = useState("");

  const [password, setPassword] = useState("");
  const [firstNameError, setFirstNameError] = useState("");
  const [lastNameError, setLastNameError] = useState("");
  const [emailError, setEmailError] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [addressError, setAddressError] = useState("");
  const [gender, setGender] = useState({
    male: false,
    female: false,
  });

  const [confirmPassword, setConfirmPassword] = useState("");
  const [confirmPhone, setPhoneError] = useState("");
  const { showAlert, closeAlert } = useAlert();

  const [isCheckedFirstBox, setIsCheckedFirstBox] = useState(false);
  const [isCheckedSecondBox, setIsCheckedSecondBox] = useState(false);

  const handleChangeCheckedFirstBox = (e) => {
    setIsCheckedFirstBox(e.target.checked);
  };
  const handleChangeCheckedSecondBox = (e) => {
    setIsCheckedSecondBox(e.target.checked);
  };

  useEffect(() => {
    if (!token) {
      const query = new URLSearchParams(location.search);
      const urlToken = query.get("token");

      if (urlToken) {
        try {
          const decoded = jwtDecode(urlToken);
          localStorage.setItem("token", urlToken);
          setToken(urlToken);
          setClientActiveId(decoded.id);
        } catch (err) {
          console.error("Invalid token in URL", err);
        }
      }
    }
  }, [token, location.search]);

  useEffect(() => {
    if (token) {
      try {
        const decoded = jwtDecode(token);
        setClientActiveId(decoded.id);
        console.log("Decoded token:", decoded);
      } catch (err) {
        console.error("Invalid token", err);
        localStorage.removeItem("token");
      }
    }
  }, [token]);

  const handleGenderChange = (event) => {
    const { name, checked } = event.target;

    setGender({
      male: name === "male" ? checked : false,
      female: name === "female" ? checked : false,
    });
  };

  const navigate = useNavigate();

  const validatePassword = (e) => {
    const password = e.target.value;
    setPassword(password);
  };

  const validateEmail = (e) => {
    const email = e.target.value;
    setEmail(email);
  };
  const validateNickname = (e) => {
    const nickname = e.target.value;
    setNickName(nickname);
  };

  const validateFirstName = (e) => {
    const firstName = e.target.value;
    setFirstName(firstName);
  };
  const validateAddress = (e) => {
    const address = e.target.value;
    setAddress(address);
  };
  const validateLastName = (e) => {
    const lastName = e.target.value;
    setLastName(lastName);
  };
  const validateConfirmPassword = (e) => {
    const confirmPassword = e.target.value;
    setConfirmPassword(confirmPassword);

    // Example password validation criteria
  };
  const validatePhone = (e) => {
    const phone = e.target.value;
    setPhone(phone);

    // Example password validation criteria
  };

  const onRegister = async (e) => {
    setEmailError("");
    setPasswordError("");
    setFirstNameError("");
    setAddressError("");
    setLastNameError("");
    console.log(firstName);
    console.log("nestoo");
    console.log(password, "pass");

    const data = {
      first_name: firstName,
      last_name: lastName,
      email: email,
      terms_agreed: isCheckedFirstBox,
      marketing_consent: isCheckedSecondBox,
      address: address,
      nickname: nickname,
    };

    if (firstName === "") {
      console.log("usao sam ovde");
      setFirstNameError("Please enter first name");
      showAlert("Polje za ime je prazno", "error");

      return;
    }

    if (lastName === "") {
      setLastNameError("Please enter last name");
      showAlert("Polje za prezime je prazno", "error");

      return;
    }
    // if (phone === "") {
    //   setPhoneError("Please enter phone number");
    //   return;
    // }

    if (gender.male) {
      data.gender = "male";
    } else if (gender.female) {
      data.gender = "female";
    } else {
      showAlert("Niste oznacili pol", "error");
      console.error("Invalid gender selected.");
      return;
    }

    if (!isCheckedFirstBox) {
      showAlert(
        "Da biste nastavili, potrebno je da se složite sa uslovima korišćenja.",
        "error"
      );
      return;
    }
    data.id = activeClientId;
    console.log(data);

    console.log("All validations passed");
    try {
      const response = await ApiMethods.post("auth/client/register", data);

      setUser(response);

      if (response.token) {
        localStorage.setItem("token", response.token);

        showAlert("Uspesno logovanje!", "success");

        loginVerification();
      } else {
        throw new Error("Token not found in response");
      }

      console.log("ovo je response", response);
    } catch (error) {
      setEmailError("User already exist");
      showAlert(error.message, "error");
      console.error("Error during registration:", error);
    }
  };
  const onkeydown = (event) => {
    if (event.key === "Enter") {
      onRegister();
    }
  };

  // const validatePhoneNumber = (e) => {
  //   const value = e.target.value;
  //   setPhone(value);

  //   // Check if the phone number starts with +381
  //   if (!value.startsWith("+381")) {
  //     setError("Phone number must start with +381");
  //   } else {
  //     setError(""); // Clear error if valid
  //   }
  // };
  const checkAlert = (validCredentials) => {
    setAlert(validCredentials);
    setTimeout(() => {
      setAlert(undefined);
    }, 800);
  };

  return (
    <div
      style={{
        backgroundColor: "black",
        height: "auto",
      }}
    >
      <div onKeyDown={onkeydown}>
        <div style={{ display: "flex", justifyContent: "center" }}>
          <p className="register-part-par"> Dobrodošli</p>
        </div>
        <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
          <Input
            label={"Ime"}
            placeholder={"Ime"}
            id={"firstName"}
            type={"text"}
            nameInput={"firstName"}
            error={firstNameError}
            onChange={validateFirstName}
          />
          <Input
            label={"Prezime"}
            error={lastNameError}
            placeholder={"Prezime"}
            id={"lastName"}
            type={"text"}
            nameInput={"lastName"}
            onChange={validateLastName}
          />

          <Input
            label={"Nadimak"}
            placeholder={"Nadimak"}
            id={"nadimak"}
            type={"text"}
            nameInput={"address"}
            value={nickname}
            onChange={validateNickname}
          />
          {/* <Input
          label={"Phone number"}
          error={confirmPhone}
          placeholder={"+381123456789"}
          id={"phone"}
          type={"phone"}
          nameInput={"phone"}
          onChange={validatePhone}
        /> */}
          <Input
            label={"Email"}
            error={emailError}
            placeholder={"Email"}
            id={"email1"}
            type={"email"}
            nameInput={"email1"}
            onChange={validateEmail}
          />
          <Input
            label={"Adresa"}
            placeholder={"Adresa"}
            id={"adresa"}
            type={"text"}
            nameInput={"address"}
            value={address}
            onChange={validateAddress}
          />

          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "15px",
              justifyContent: "center",
              padding: "10px",
            }}
          >
            <span
              style={{
                color: "#898A8D",
                fontSize: "16px",
                fontWeight: "400",
                color: "white",
                height: "auto",
              }}
            >
              Gender
            </span>

            <input
              type="checkbox"
              name="male"
              checked={gender.male}
              onChange={handleGenderChange}
              style={{
                borderRadius: "50%",
                width: "30px",
                fontWeight: "400",
                height: "30px",
                cursor: "pointer",
                appearance: "none",
                border: "2px solid #0BF",
                backgroundColor: gender.male ? "#95E3FF" : "transparent",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontWeight: "500",
                color: gender.male ? "white" : "#0BF",
                textAlign: "center",
                fontSize: "13px",
                color: "white",
              }}
              className="gender-checkbox male-checkbox"
              data-label="M"
            />

            <input
              type="checkbox"
              name="female"
              className="gender-checkbox female-checkbox"
              checked={gender.female}
              onChange={handleGenderChange}
              style={{
                color: "#898a8d",
                borderRadius: "50%",
                width: "30px",
                height: "30px",
                cursor: "pointer",
                appearance: "none",
                border: "2px solid #FB8BD2",
                backgroundColor: gender.female ? "#FFD6F0" : "transparent",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontWeight: "bold",
                color: gender.female ? "white" : "#FB8BD2",
                textAlign: "center",
                fontSize: "13px",
                fontWeight: "400",
              }}
              data-label="F"
            />
          </div>
          {/* <Input
            label={"Potvrda lozinke"}
            error={passwordError}
            placeholder={"Potvrda lozinke"}
            id={"confirm"}
            type={"password"}
            nameInput={"confirm"}
            value={password}
            onChange={validateConfirmPassword}
          />  */}
        </div>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            paddingLeft: "20px",
            justifyContent: "center",
          }}
        >
          <FormControlLabel
            className="mui-terms"
            sx={{
              whiteSpace: "nowrap",
              display: "flex",
              alignItems: "center",
              "& .MuiFormControlLabel-label": {
                fontSize: "12px",
              },
              color: "white",
              "&.Mui-checked": {
                color: "#13c552",
              },
              borderColor: "red",
              width: "100%",
            }}
            required
            control={
              <Checkbox
                onChange={handleChangeCheckedFirstBox}
                checked={isCheckedFirstBox}
                sx={{
                  color: "red",
                  "&.Mui-checked": {
                    color: "red",
                  },
                }}
              />
            }
            label="Prihvatam da treniram na svoju odgovornost"
          />
        </Box>

        <Box
          sx={{ display: "flex", alignItems: "center", paddingLeft: "10px" }}
        >
          <FormControlLabel
            sx={{
              display: "flex",
              alignItems: "center",
              "& .MuiFormControlLabel-label": {
                fontSize: "12px",
              },
              color: "white",
              "&.Mui-checked": {
                color: "#13c552",
              },
              borderColor: "red",
              width: "100%",
              paddingLeft: "10px",
            }}
            control={
              <Checkbox
                onChange={handleChangeCheckedSecondBox}
                sx={{
                  color: "red",
                  "&.Mui-checked": {
                    color: "red",
                  },
                }}
              />
            }
            label="Slažem se sa korišćenjem mojih podataka u marketinške svrhe"
          />
        </Box>

        <div
          // onClick={() => navigate("/forgotPassword")}
          className="div-forgot-password"
        >
          {/* <p className="forgot-password-par"> Zaboravili ste lozinku?</p> */}
        </div>
        <div
          className="register-div-button button-new"
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Button
            className={"register-button button-hitfit"}
            type="submit"
            name={"Registruj se"}
            onClick={onRegister}
          />
        </div>
      </div>
    </div>
  );
};

export default Register;
